import React from 'react';
import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import logo from '../../../assets/images/logo.png';
import {useTranslation} from "react-i18next";

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        padding: 30,
    },
    centeredBox: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 16,
    },
    logo: {
        width: 100,
        marginBottom: 8,
    },
    grayText: {
        color: '#8c8c8c',
        fontSize: 15,
        marginBottom: 4,
    },
    dateText: {
        color: '#9e9e9e',
        fontSize: 15,
        marginBottom: 2,
        borderBottom: '2px dashed #9e9e9e',
        width: '100%',
        textAlign: 'center',
        paddingBottom: 8,
    },
    box: {
        marginBottom: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5,
    },
    box2: {
        marginBottom: 25,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5,
    },
    lastBox: {
        borderTop: '2px dashed #9e9e9e',
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5,
        marginTop: 8,
        paddingTop: 8,
    },
    title: {
        color: '#8c8c8c',
        fontSize: 15,
    },
    content: {
        color: '#000000c7',
        fontSize: 18,
        fontWeight: 600,
    },
    operationCompleted: {
        border: "2px solid #0666eb",
        padding: 30,
        width: "60%",
        margin: "50px auto 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    operationCompletedText: {
        color: "#0666eb", fontSize: 20
    }
});

const PDFDocument = ({ senderPhone, senderName, amount, recipientPhone, recipientName, comment, comicion, documentNumber }) => {
    const date = new Date();
    const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    }).replace(',', '');
    const {t} = useTranslation();
    const formattedAmount = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2 }).format(amount).replace(",", ".");

    return (
        <Document>
            <Page size="A4" style={styles.container}>
                <View style={styles.centeredBox}>
                    <Image style={styles.logo} src={logo} alt="logo" />
                    <Text style={styles.grayText}>{t("Receipt of the transaction")}</Text>
                    <Text style={styles.dateText}>{formattedDate}</Text>
                </View>
                <View style={styles.box}>
                    <Text style={styles.title}>{t("Operation")}</Text>
                    <Text style={styles.content}>Transferir al cliente TipsSi</Text>
                </View>
                <View style={styles.box}>
                    <Text style={styles.title}>{t("Recipient name")}</Text>
                    <Text style={styles.content}>{recipientName}</Text>
                </View>
                <View style={styles.box2}>
                    <Text style={styles.title}>{t("Recipient phone")}</Text>
                    <Text style={styles.content}>{recipientPhone}</Text>
                </View>
                <View style={styles.box}>
                    <Text style={styles.title}>{t("Sender name")}</Text>
                    <Text style={styles.content}>{senderName}</Text>
                </View>
                <View style={styles.box}>
                    <Text style={styles.title}>{t("Sender phone")}</Text>
                    <Text style={styles.content}>{senderPhone}</Text>
                </View>
                <View style={styles.box}>
                    <Text style={styles.title}>{t("Amount")}</Text>
                    <Text style={styles.content}>{formattedAmount}€</Text>
                </View>
                <View style={styles.box}>
                    <Text style={styles.title}>{t("Commission")}</Text>
                    <Text style={styles.content}>{comicion}</Text>
                </View>
                <View style={styles.box}>
                    <Text style={styles.title}>{t("Document Number")}</Text>
                    <Text style={styles.content}>{documentNumber}</Text>
                </View>
                <View style={styles.lastBox}>
                    <Text style={styles.title}>{t("Additional information")}</Text>
                    <Text style={styles.content}>{t("If you have sent money to the wrong person,  contact the recipient of the transfer.  Only the recipient can return the money.")}</Text>
                </View>
                <View style={styles.operationCompleted}>
                    <Text style={styles.operationCompletedText}>{t("Operation performed")}</Text>
                </View>
            </Page>
        </Document>
    );
};

export default PDFDocument;
